import { CurrenciesPage } from 'features/currencies';

export const AdminCurrenciesPage: React.FC = () => <CurrenciesPage />;
